import request from "superagent";
import { memoize } from "./utils";

const Datasource = memoize(
  async (url, key, options = {}) => {
    if (options.type === "map") {
      const req = await request.get(url).responseType("arraybuffer");
      return req.body;
    } else {
      const req = await request.get(url).parse(text => text); //Do not parse regardless of mime
      return req.text;
    }
  },
  (url, key, options) => key
);

export default Datasource;
